import * as types from "../../redux/types";
import backend from "../../api/api";
import { store } from "../../redux/store";
import { message } from "antd";
import dayjs from 'dayjs';


const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

// export const createAppointment = (formValues) => async (dispatch) => {
//   formValues["data"] = "";
//   console.log(formValues);
//   try {
//     const response = await backend.post(
//       "api/contact/appointment/",
//       { ...formValues },
//       getConfig()
//     );
//     console.log(response);
//     if (response.status === 201) {
//       return response.data;
//     }
//   } catch (error) {
//     alert(error);
//   }
// };

export const createAppointment = (formValues) => async (dispatch) => {
  // Ensure the date is in the correct format
  const formattedDate = formValues.date
    ? dayjs(formValues.date).format("YYYY-MM-DD")
    : null;

  // Construct payload with correct date format
  const payload = {
    ...formValues,
    date: formattedDate,
    // data: "", // Keeping this as per your existing logic
  };

  console.log(payload); // Debugging: Check if the payload is correct

  try {
    const response = await backend.post(
      "api/contact/appointment/", // Ensure the leading slash is present
      payload,
      getConfig()
    );

    console.log(response);

    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    console.error("Error creating appointment:", error); 
    alert(error.response.data.message || "Failed to create appointment");
  }
};


export const getAllAppointment = () => async (dispatch) => {
  try {
    const response = await backend.get(
      "api/contact/appointment/",
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificAppointment = (id) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/contact/appointment/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteAppointment = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/contact/appointment/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      return response;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateAppointment = (id, formValues) => async (dispatch) => {
  formValues["data"] = "";
  try {
    const response = await backend.patch(
      `api/contact/appointment/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error.response);
  }
};
